import { createFileRoute } from '@tanstack/react-router'

import { MenuPage } from '@/pages/menu/menuPage'

export const Route = createFileRoute('/menu')({
	component: MenuPage,
})
